@switch (column().key) {
  @case (getColumnKey('description')) {
    @if (isNotNil(model().description)) {
      <app-summernote-html-preview [html]="model().description" />
    } @else {
      <app-no-data />
    }
  }

  @case (getColumnKey('countries')) {
    @for (country of model().countries; track country; let isLast = $last) {
      <span>{{ country.label }}</span>

      @if (!isLast) {
        <span>, </span>
      }
    }
  }

  @default {
    <app-table-body-no-reference-cell [columnKey]="column().key" />
  }
}
